import {
	GetRewardResponse,
	RequestEnginePayload,
	RewardsEngine,
} from "../domain/reward.interface";
import { instanceBo } from "../utils/axios.create";

const findAll = async (
	options: { eventType?: string; event?: string } = {},
): Promise<RewardsEngine[]> => {
	const { eventType, event } = options;
	const params = new URLSearchParams();

	if (eventType) params.append("eventType", eventType);
	if (event) params.append("event", event);

	const queryString = params.toString();
	const url = queryString
		? `/reward-configurations?${queryString}`
		: "/reward-configurations";

	return instanceBo
		.get(url)
		.then((res) => res.data.body)
		.catch((err) => Promise.reject(err.response.data));
};

const create = async (data: Partial<RewardsEngine>): Promise<RewardsEngine> => {
	return instanceBo
		.post("/reward-configurations", data)
		.then((res) => res.data.body)
		.catch((err) => Promise.reject(err.response.data));
};

const update = async (
	id: string,
	data: Partial<RewardsEngine>,
): Promise<RewardsEngine> => {
	return instanceBo
		.put(`/reward-configurations/${id}`, data)
		.then((res) => res.data.body)
		.catch((err) => Promise.reject(err.response.data));
};

const remove = async (id: string): Promise<void> => {
	return instanceBo
		.delete(`/reward-configurations/${id}`)
		.then((res) => res.data)
		.catch((err) => Promise.reject(err.response.data));
};

const getReward = async (
	data: RequestEnginePayload,
): Promise<GetRewardResponse> => {
	return instanceBo
		.post("/reward-configurations/engine", data)
		.then((res) => res.data.body)
		.catch((err) => Promise.reject(err.response.data));
};

const calculateVisitNumber = async (
	enrollmentId: string,
	programId: string,
): Promise<number> => {
	return instanceBo
		.post("/reward-configurations/calculate", { enrollmentId, programId })
		.then((res) => res.data.body.nextRelativeVisitIndex)
		.catch((err) => Promise.reject(err.response.data));
};

export const rewardsEngineService = {
	findAll,
	create,
	update,
	remove,
	getReward,
	calculateVisitNumber,
};
